<template>
  <div :class="themeStyleVs === 2 ? 'hot_page black_version' : 'hot_page'">
    <header>
      <navigation :text="'热门推荐'" :searchShow="true"></navigation>
      <div class="nav_main">
        <ul>
          <li
            :class="index === navId ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="antiShakeBtn(index)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </header>
    <div class="content_main mn_main" v-show="navId === 0">
      <ul class="mn_tab">
        <li
          :class="hotTacticTabId === item.id ? 'active' : ''"
          v-for="(item, index) in mnTabList"
          :key="index"
          @click="checkHotTab(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
      <div class="list_main" v-if="hotTactic.length > 0 && tacticQuery">
        <div>
          <div
            class="main"
            v-for="(item, index) in hotTactic"
            :key="index"
            @click.stop="goLink(item, 0)"
          >
            <div class="top">
              <span class="tit">{{ item.s_name }}</span>
              <span
                :class="item.isGz ? 'btn followed' : 'btn'"
                @click.stop="followCheck(item, index, 1)"
                >{{ item.isGz ? '已关注' : '关注' }}</span
              >
            </div>
            <div class="intro_box">{{ item.s_desc }}</div>
            <div class="detail_cante">
              <div class="li_box">
                <div class="lf_box">
                  <p :class="item.RiZhangFu | formateRedGreen">
                    {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                  </p>
                  <p>日涨幅</p>
                </div>
                <div class="rg_box">
                  <p>{{ item.XinHaoShuLiang }}只</p>
                  <p>今日信号</p>
                </div>
              </div>
              <div class="li_box">
                <div class="lf_box">
                  <p :class="item.BestAvgRate | formateRedGreen">
                    {{ toFixedNum(item.BestAvgRate * 100, 2, '%')
                    }}<span>持股{{ item.BestAvgCycle }}天</span>
                  </p>
                  <p>最优平均涨幅</p>
                </div>
                <div class="rg_box">
                  <p :class="item.MaxRiseRate | formateRedGreen">
                    {{ toFixedNum(item.MaxRiseRate * 100, 2, '%')
                    }}<span>持股{{ item.MaxRiseCycle }}天</span>
                  </p>
                  <p>最大上涨概率</p>
                </div>
              </div>
            </div>
          </div>
          <p class="isNoMoreValue" v-if="isNoMoreValue">没有更多了</p>
        </div>
      </div>

      <van-empty
        v-if="tacticQuery && !hotTactic.length"
        class="custom-image"
        :image="not_data"
        description="暂未获取到数据"
      />
    </div>
    <div class="content_main mn_main" v-show="navId === 1">
      <ul class="mn_tab">
        <li
          :class="mnTabId === item.id ? 'active' : ''"
          v-for="(item, index) in mnTabList"
          :key="index"
          @click="checkMnTab(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollFn"
        class="list_main"
      >
        <div v-if="mnList.length > 0 && mnQuery">
          <div
            class="main"
            v-for="(item, index) in mnList"
            :key="index"
            @click.stop="goLink(item, 1)"
          >
            <div class="top">
              <span class="tit">{{ item.ts_name }} <span v-if="item.review_status == '1'" class="pay_icon" ><img :src="payImg" alt="" srcset=""></span> </span>
              <span
                :class="item.isGz ? 'btn followed' : 'btn'"
                @click.stop="followCheck(item, index, 3)"
                >{{ item.isGz ? '已关注' : '关注' }}</span
              >
            </div>
            <div class="cen_main">
              <ul>
                <li>
                  <p :class="item.lastProfit.totalRisk | formateRedGreen">
                    {{ toFixedNum(item.lastProfit.totalRisk * 100, 2, '%') }}
                  </p>
                  <p>创建后收益</p>
                </li>
                <li>
                  <p :class="item.lastProfit.todayRisk | formateRedGreen">
                    {{ toFixedNum(item.lastProfit.todayRisk * 100, 2, '%') }}
                  </p>
                  <p>今日收益</p>
                </li>
                <li>
                  <p>{{ toFixedNum(item.lastProfit.maxRetreatRate * 100, 2, '%') }}</p>
                  <p>最大回撤</p>
                </li>
              </ul>
            </div>
            <div class="chart_box" :id="'chartMn4' + index"></div>
            <div class="food_box clearfix">
              <span class="time_box">自{{ convertTime(item.lineData.xData[0]) }}</span>
              <div class="right_box">
                <span>收益</span>
                <span>沪深</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>

      <van-empty
        v-if="mnQuery && !mnList.length"
        class="custom-image"
        :image="not_data"
        description="暂未获取到数据"
      />
    </div>
  </div>
</template>

<script>
import { getHotTactics, getFactorHq, addMyFavor, delMyFavor, getHotMokpanel } from '@/api/index.js';
import navigation from '@/components/navigation.vue';
import mixin from '@/mixins/index.js';
import { fangDouFun,compareVersions } from '@/utils/format.js';
import { Toast } from 'vant';
export default {
  name: 'Hot',
  mixins: [mixin],
  components: {
    navigation,
    Toast
  },
  data() {
    return {
      not_data: require('../../assets/image/notData.png'),
      upImg: require('../../assets/image/up_jian.png'),
      payImg: require('../../assets/image/pay-icon.png'),
      // navList: ["热门因子", "热门模拟交易", "热门策略"],
      navList: ['热门策略', '热门模拟交易'],
      navId: 0,
      hotDivisor: [
        {
          name: '智能机器',
          intro: '智能机器概念板块的成分股',
          follow: false,
          zf: '2.45',
          owning: '大智慧板块-概念板块',
          signal: 47,
          limit: 5,
          exceed: 15,
          stockList: [
            {
              name: '鼎智科技',
              obj: '',
              zf: 29.98
            },
            {
              name: '奥比中光',
              obj: '',
              zf: 29.98
            }
          ]
        }
      ],
      loading: true,
      finished: true,
      mnTabList: [
        {
          name: '全部',
          id: 'all'
        },
        {
          name: '短周期',
          id: '1'
        },
        {
          name: '中周期',
          id: '2'
        },
        {
          name: '长周期',
          id: '3'
        }
      ],
      mnTabId: 'all',
      mnList: [],
      mnQuery: false,
      chartList: [],
      hotTactic: [],
      tacticQuery: false,
      hotTacticTabId: 'all',
      hotTacticInterval: null,
      themeStyleVs: 1,
      loading: false,
      finished: false,
      finishedText: '没有更多了',
      page: 1,
      linkData: '',
      isNoMoreValue: false,
      isVip: false
    };
  },
  filters: {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  created() {
    let u = navigator.userAgent;
    if (
      typeof DzhAppJs !== 'undefined' &&
      u.indexOf('iPhone') > -1 &&
      !compareVersions(this.getUrlQuery('version'),9.65)
    ) {
      let obj = { navBarHidden: 1, titleHidden: 1 };
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', JSON.stringify(obj), '');
    }
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
  },
  mounted() {
    this.navId = this.getUrlQuery('navId') ? Number(this.getUrlQuery('navId')) : 0;
    this.loading = true;
    this.$nextTick(function () {
      if (this.navId === 0) {
        this.getHotTactic();
      } else {
        this.getMokpanel();
      }
    });
  },
  methods: {
    compareVersions,
    // 点击头部nav栏
    antiShakeBtn: function (val) {
      let that = this;
      if (that.navId === val) return false;
      that.page = 1;
      that.navId = val;
      that.mnList = [];
      that.chartList = [];
      that.hotTactic = [];
      that.isNoMoreValue = false;
      that.loading = true;
      if (val === 0) {
        that.$router.push({
          query: {
            ...that.$route.query, // 保留原有的查询参数
            navId: 0, // 添加或修改指定的参数
            themeStyleVs: this.themeStyleVs,
            version: this.$route.query.version || ''
          }
        });
        that.getHotTactic();
      } else {
        that.$router.push({
          query: {
            ...that.$route.query, // 保留原有的查询参数
            navId: 1, // 添加或修改指定的参数
            version: this.$route.query.version || ''
          }
        });
        if (that.hotTacticInterval) {
          window.clearInterval(that.hotTacticInterval);
          that.hotTacticInterval = null;
        }
        that.getMokpanel();
      }
    },

    //模拟交易中type切换
    checkMnTab: fangDouFun(
      function (...args) {
        this.mnTabCheck(...args);
      },
      200,
      true
    ),
    mnTabCheck: function (id) {
      let that = this;
      that.mnTabId = id;
      that.chartList = [];
      that.mnList = [];
      that.page = 1;
      that.loading = true;
      that.$nextTick(function () {
        that.getMokpanel();
      });
    },

    checkHotTab: fangDouFun(
      function (...args) {
        this.hotTabBtn(...args);
      },
      200,
      true
    ),
    hotTabBtn: function (id) {
      let that = this;
      that.tacticQuery = false;
      this.hotTacticTabId = id;
      if (this.hotTacticInterval) {
        window.clearInterval(that.hotTacticInterval);
        that.hotTacticInterval = null;
      }
      this.$nextTick(function () {
        that.hotTactic = [];
        that.page = 1;
        that.loading = true;
        this.getHotTactic();
      });
    },
    // 创建图表
    chartFn: function () {
      let that = this;
      let dataList = that.mnList;
      dataList.forEach((item, index) => {
        if (!that.chartList[index]) {
          let chartDom = document.getElementById('chartMn4' + index);
          that.chartList[index] = that.$echarts.init(chartDom);
          window.addEventListener('resize', that.resizeHandler);
        }
        let xData = item.lineData.xData;
        let dataSy = item.lineData.profitRate;
        let dataHs = item.lineData.hs300Rate;
        let option = {
          color: ['#286DF7', '#FF770C'],
          grid: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          },
          xAxis: {
            show: false,
            type: 'category',
            data: xData
          },
          yAxis: {
            show: false,
            type: 'value'
          },
          series: [
            {
              symbol: 'none',
              data: dataSy,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#000000' //改变折线颜色
                }
              }
            },
            {
              symbol: 'none',
              data: dataHs,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#FF770C' //改变折线颜色
                }
              },
              markLine: {
                symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                data: [
                  {
                    silent: false,
                    yAxis: 0, // 表现自定义的位置，可赋值
                    label: {
                      position: 'end', // 表现内容展示的位置
                      formatter: '中文路均值', // 标线展示的内容
                      color: '#8C8C8C', // 展示内容颜色
                      show: false
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: that.themeStyleVs === 2 ? '#6b7687' : 'rgba(0, 0, 0, 0.2)',
                      width: 1
                    } // 样式： 线型、颜色、线宽
                  }
                ]
              }
            }
          ]
        };
        option && that.chartList[index].setOption(option);
      });
    },
    resizeHandler() {
      this.chartList.forEach((item) => {
        if (item) {
          item.resize();
        }
      });
    },
    scrollFnMn: function () {
      let that = this;
      that.loading = true;
      that.getHotTactic();
    },
    // 获取热门策略接口数据
    getHotTactic: function () {
      let that = this;
      let obj = {
        limit: 99,
        type: that.hotTacticTabId,
        type_info: compareVersions(that.$route.query.version , 9.69) ? 0 : 1 //0全部  1A股 2ETF
      };
      getHotTactics(obj)
        .then((res) => {
          that.type_info = res.data.type_info;
          if (res.err === 200 && res.data.length > 0) {
            that.isNoMoreValue = true;
            that.hotTactic = [...that.hotTactic, ...res.data];
            that.$nextTick(function () {
              let idKeys = res.data.map((item) => {
                return item.f_id_arr.replaceAll(',', '_');
              });
              idKeys = idKeys.toString();
              that.getHqData(idKeys, res.data);
              // that.hotTacticInterval = window.setInterval(() => {
              //   that.getHqData(idKeys, res.data);
              // }, 60000);
            });
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
          }
        })
        .catch(() => {
          that.finished = true;
          that.loading = true;
          that.finishedText = '';
        });
    },
    // 获取行情数据
    getHqData: function (idKeys, data) {
      let that = this;
      let obj = {
        type: 'cl',
        groupID: idKeys,
        field: 'Desc'
      };
      getFactorHq(obj)
        .then((res) => {
          if (res.err === 200) {
            if (res.data.length < 10) {
              //是否已加载完成，加载完成后不再触发load事件
              that.finished = true;
            } else {
              that.loading = false;
              that.page += 1;
              that.finished = false;
            }
            that.hotTactic.forEach((item, index) => {
              res.data.forEach((item1) => {
                if (item.f_id_arr.replaceAll(',', '_') === item1.ID) {
                  that.$set(that.hotTactic[index], 'RiZhangFu', item1.RiZhangFu);
                  that.$set(that.hotTactic[index], 'XinHaoShuLiang', item1.XinHaoShuLiang);
                }
              });
            });

            that.tacticQuery = true;
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
          }
        })
        .catch(() => {
          that.finished = true;
          that.loading = true;
          that.finishedText = '';
        });
    },
    // 点击关注或者取消关注按钮
    followCheck: function (item, index, type) {
      let that = this;
      if (!item.isGz) {
        that.addFavor(item, index, type);
      } else {
        that.delFavor(item, index, type);
      }
    },
    // 关注请求
    addFavor: function (item, index, type) {
      let that = this;
      let obj;
      if (type === 1) {
        obj = {
          type: type,
          id: item.s_id,
          s_name: item.s_name,
          f_id_arr: item.f_id_arr,
          creator: item.creator,
          type_info: item.type_info
        };
      } else {
        obj = {
          type: type,
          id: item.zj_id,
          s_name: item.ts_name,
          f_id_arr: item.h_id,
          creator: item.uname,
          counter_num: item.counter_num
        };
      }
      addMyFavor(obj).then((res) => {
        if (res.err === 200) {
          if (type === 1) {
            that.hotTactic[index].isGz = true;
            Toast('关注成功');
          } else {
            that.mnList[index].isGz = true;
            Toast('关注成功');
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    // 取消关注按钮
    delFavor: function (item, index, type) {
      let that = this;
      let obj;
      if (type === 1) {
        obj = {
          type: type,
          id: item.s_id
        };
      } else {
        obj = {
          type: type,
          id: item.zj_id
        };
      }
      delMyFavor(obj).then((res) => {
        if (res.err === 200) {
          if (type === 1) {
            that.hotTactic[index].isGz = false;
            Toast('取消成功');
          } else {
            that.mnList[index].isGz = false;
            Toast('取消成功');
          }
        }
      });
    },
    // 获取热门模拟交易数据
    getMokpanel: function () {
      let that = this;
      let obj = {
        type: that.mnTabId,
        limit: 10,
        page: that.page
      };
      getHotMokpanel(obj)
        .then((res) => {
          if (res.err === 200) {
            that.mnList = [...that.mnList, ...res.data];
            that.mnQuery = true;
            that.$nextTick(function () {
              if (res.data.length < 10) {
                //是否已加载完成，加载完成后不再触发load事件
                that.finished = true;
              } else {
                that.loading = false;
                that.page += 1;
                that.finished = false;
              }
              that.chartFn();
            });
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
          }
        })
        .catch(() => {
          that.finished = true;
          that.loading = true;
          that.finishedText = '';
        });
    },
    // 热门模拟交易分页
    scrollFn: function () {
      let that = this;
      that.loading = true;
      that.getMokpanel();
    },

    goLink: function (item, id) {
      let that = this;

      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0703'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        that.linkData = item;
        if (id === 0) {
          this.$router.push({
            path: '/clDetail',
            name: 'clDetail',
            query: {
              token: this.$route.query.token || '',
              s_id: item.s_id,
              type: 'hot',
              sourceType: true,
              themeStyleVs: this.themeStyleVs,
              version: this.$route.query.version
            }
          });
        } else {
          this.$router.push({
            path: '/mnDetail',
            name: 'mnDetail',
            query: {
              token: this.$route.query.token || '',
              zj_id: item.zj_id,
              type: 'hot',
              sourceType: true,
              themeStyleVs: this.themeStyleVs,
              version: this.$route.query.version
            }
          });
        }
      }
    }
  },

  beforeDestroy() {
    let that = this;
    that.chartList.forEach((item) => {
      if (item) {
        item.dispose();
      }
    });
    that.chartList = null;
    // window.clearInterval(that.hotTacticInterval);
    // that.hotTacticInterval = null;
    window.removeEventListener('resize', this.resizeHandler);
  }
};
</script>
<style lang="less" scoped>
.isNoMoreValue {
  color: #969799;
  font-size: 12px;
  line-height: 26px;
  text-align: center;
}
.hot_page {
  width: 100%;
  height: 100vh;
  header {
    padding-top: 44px;
    .nav_main {
      width: 100%;
      ul {
        li {
          display: inline-block;
          width: 50%;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          color: #000;
          &.active {
            position: relative;
            &::before {
              content: '';
              width: 100%;
              height: 1px;
              position: absolute;
              bottom: 0;
              left: 0;
              background-color: #286df7;
            }
          }
        }
      }
    }
  }
  .content_main {
    width: 100%;
    height: calc(100% - 120px);
    background-color: #f4f4f4;
    overflow: hidden;
    overflow-y: scroll;
    padding: 7px 12px;
    .main {
      width: 100%;
      background-color: #fff;
      box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 15px 12px;
      box-sizing: border-box;
      .top {
        margin-bottom: 8px;
        .tit {
          font-size: 16px;
          color: #373a4d;
          font-weight: 500;
        }
        .pay_icon{
          width: 32px;
          height: 17px;
          display: inline-block;
          margin-left: 4px;
          img{
            width: 100%;
            height: 100%;
            display: inline-block;
          }
        }
        .btn {
          padding: 4px 12px;
          box-sizing: border-box;
          font-size: 10px;
          color: #286df7;
          font-weight: 500;
          background: rgba(40, 109, 247, 0.1);
          border-radius: 4px;
          float: right;
          line-height: 14px;
          &.followed {
            background: rgba(153, 153, 153, 0.0588235);
            border-radius: 2px;
            color: #999999;
          }
        }
      }
      .finish {
        font-size: 12px;
        color: #666666;
        margin-bottom: 8px;
      }
      .cen_top {
        width: 100%;
        margin-bottom: 4px;
        .left {
          width: 106px;
          height: 52px;
          box-sizing: border-box;
          border-radius: 4px;
          background-color: #f9f9f9;
          float: left;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          p {
            &:first-child {
              font-size: 16px;
              color: #ef3939;
            }
            &:last-child {
              font-size: 12px;
              color: #999999;
            }
          }
        }
        .right {
          width: 4.12rem;
          height: 52px;
          background: #f9f9f9;
          border-radius: 4px;
          float: right;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          p {
            &:first-child {
              font-size: 12px;
              font-weight: 500;
              color: #373a4d;
            }
            &:last-child {
              font-size: 12px;
              color: #999999;
            }
          }
        }
      }
      .cen_btm {
        width: 100%;
        height: 58px;
        background-color: #f9f9f9;
        margin-bottom: 4px;
        ul {
          display: flex;
          width: 100%;
          height: 100%;
          li {
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            p {
              &:first-child {
                font-size: 16px;
                font-weight: 500;
                color: #373a4d;
              }
              &:last-child {
                font-size: 12px;
                color: #999999;
              }
            }
          }
        }
      }
      .btm_main {
        width: 100%;
        ul {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          li {
            background-color: #fff6f6;
            width: 157px;
            height: 24px;
            border-radius: 4px;
            padding-left: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            img {
              width: 8px;
              height: 10px;
              margin-right: 10px;
              display: inline-block;
            }
            .name_text {
              font-size: 12px;
              color: #666666;
              margin-right: 4px;
            }
            .num_main {
              font-size: 12px;
              color: #ef3939;
            }
          }
        }
      }
    }
  }
  .mn_main {
    padding: 11px 12px;
    overflow-y: hidden;
    .mn_tab {
      width: 100%;
      margin-bottom: 8px;
      display: flex;
      li {
        padding: 4px 16px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 2px;
        margin-right: 8px;
        font-size: 12px;
        color: #373a4d;
        &.active {
          background-color: #286df7;
          color: #fff;
        }
      }
    }
    .list_main {
      height: calc(100% - 24px);
      width: 100%;
      overflow-y: scroll;
      .main {
        margin-bottom: 8px;
      }
      .cen_main {
        width: 100%;
        margin-bottom: 4px;
        ul {
          width: 100%;
          display: flex;
          li {
            width: 106px;
            height: 52px;
            background: #f9f9f9;
            border-radius: 4px;
            margin-right: 4px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            &:last-child {
              margin-right: 0;
            }
            p {
              &:first-child {
                font-size: 16px;
                // color: #EF3939;
                font-weight: 500;
              }
              &:last-child {
                font-size: 12px;
                color: #999999;
              }
            }
          }
        }
      }
      .chart_box {
        width: 100%;
        height: 52px;
        background-color: #f8f8f8;
        margin-bottom: 2px;
      }
      .food_box {
        width: 100%;
        padding-left: 8px;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        .time_box {
          float: left;
        }
        .right_box {
          float: right;
          span {
            position: relative;
            &:first-child {
              margin-right: 17px;
              position: relative;
              &::before {
                background-color: #286df7;
              }
            }
            &:last-child {
              &::before {
                background-color: #ff770c;
              }
            }
            &::before {
              content: '';
              width: 4px;
              height: 4px;
              border-radius: 50%;
              position: absolute;
              top: 7px;
              left: -8px;
            }
          }
        }
      }
    }

    .intro_box {
      font-size: 12px;
      line-height: 16px;
      color: #666666;
      margin-bottom: 8px;
    }
    .detail_cante {
      width: 100%;
      .li_box {
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:last-child {
          margin-bottom: 0;
        }
        div {
          width: 158px;
          padding: 9px 0;
          box-sizing: border-box;
          background: #f9f9f9;
          border-radius: 4px;
          text-align: center;
          p {
            span {
              font-size: 10px;
              color: #666666;
              margin-left: 4px;
            }
            &:first-child {
              font-weight: 500;
              font-size: 16px;
              color: #373a4d;
            }
            &:last-child {
              font-size: 12px;
              color: #999999;
              line-height: 14px;
            }
          }
        }
      }
    }
  }
}
.hot_page {
  &.black_version {
    header {
      background-color: #181a23;
      .navget_main {
        color: #e4e9fe;
      }
      .nav_main {
        ul {
          li {
            color: #e4e9fe;
            &.active {
              &::before {
                background-color: #286df7;
              }
            }
          }
        }
      }
    }
    .mn_main {
      background-color: #0c0f13;
      .mn_tab {
        li {
          background-color: #1d202d;
          color: #e4e9fe;
          &.active {
            background-color: #3b85fe;
            color: #ffffff;
          }
        }
      }
      .list_main {
        .main {
          background-color: #181a23;
          box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
          .top {
            .tit {
              color: #e4e9fe;
            }
          }
          .intro_box {
            color: #aab9d1;
          }
          .detail_cante {
            .li_box {
              div {
                background-color: #1d202d;
                p {
                  &:first-child {
                    color: #e4e9fe;
                  }
                  &:last-child {
                    color: #6b7687;
                  }
                  span {
                    color: #aab9d1;
                  }
                }
              }
            }
          }
        }
        .cen_main {
          ul {
            li {
              background: #1d202d;
              p {
                &:first-child {
                  color: #e4e9fe;
                }
                &:last-child {
                  color: #6b7687;
                }
              }
            }
          }
        }
        .chart_box {
          background-color: #1d202d;
        }
        .food_box {
          color: #6b7687;
        }
      }
    }
  }
}
</style>
<style>
.van-cell {
  padding: 0;
  background: none;
  margin-bottom: 8px;
  border-radius: 8px;
  line-height: normal;
}
.van-loading__text {
  font-size: 12px;
}
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  font-size: 12px;
  line-height: 20px;
}
</style>
